import { BannerLayout } from '../Shares/BannerLayout';
import { BattlesBannerSlide } from './BattlesBannerSlide';
export const BattlesBanner: React.FC = () => {
  return <BannerLayout>
      <BattlesBannerSlide />
      <BattlesBannerSlide />
      <BattlesBannerSlide />
      <BattlesBannerSlide />
    </BannerLayout>;
};